/**
 * Reveal Cover Script
 * - Confetti explosion on click
 * - Smooth transition to buy container
 * - Persistent reveal state (doesn't reset on tab change)
 */

document.addEventListener("DOMContentLoaded", function() {
  const revealCover = document.getElementById('reveal-cover');
  const buyOnlineContainer = document.getElementById('bun-buy-online-container');
  
  // Exit if elements don't exist
  if (!revealCover || !buyOnlineContainer) return;
  
  // Check if already revealed (for persistence across tab changes)
  let isRevealed = false;
  
  // Initially hide the Buy Online Container
  buyOnlineContainer.style.display = 'none';

  // Set a flag to ensure confetti triggers only once
  let confettiTriggered = false;

  // Function to handle reveal (confetti + show container)
  function handleReveal() {
    // Don't reveal again if already revealed
    if (isRevealed) return;
    
    // Mark as revealed
    isRevealed = true;
    
    // Trigger the confetti explosion if not already triggered
    if (!confettiTriggered && typeof confetti === 'function') {
      confetti({
        particleCount: 50,
        spread: 100,
        scalar: 1.5,
        origin: { x: 0.5, y: 0.5 },
        colors: ['#082944', '#ffc106', '#3f84ae']
      });
      confettiTriggered = true;
    }
    
    // Hide the reveal-cover container and show the Buy Online Container
    revealCover.style.display = 'none';
    buyOnlineContainer.style.display = 'block';
    
    setTimeout(function() {
      buyOnlineContainer.classList.add('visible');
    }, 10);
  }

  // Listen for clicks on the entire reveal-cover container
  revealCover.addEventListener('click', handleReveal);
  
  // Also listen for clicks specifically on the reveal-banner
  const revealBanner = revealCover.querySelector('.reveal-banner');
  if (revealBanner) {
    revealBanner.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent double-triggering
      handleReveal();
    });
  }
  
  // Monitor for tab changes and maintain reveal state
  // The external shop-form script may hide/show containers when switching tabs
  // We need to override that behavior if already revealed
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
        // If we've already revealed, keep reveal-cover hidden
        if (isRevealed && revealCover.style.display !== 'none') {
          revealCover.style.display = 'none';
        }
        // If we've already revealed, keep buy container visible when on Buy tab
        const buyTab = document.getElementById('bun-tab-buy');
        if (isRevealed && buyTab && buyTab.classList.contains('active')) {
          if (buyOnlineContainer.style.display === 'none') {
            buyOnlineContainer.style.display = 'block';
          }
        }
      }
    });
  });
  
  // Observe style changes on both elements
  observer.observe(revealCover, { attributes: true });
  observer.observe(buyOnlineContainer, { attributes: true });
});
